<template>
    <div class="quote-segment">
        <figure>
            <blockquote class="quote-segment__quote">
                <p>{{ segmentData.text || "Quote" }}</p>
            </blockquote>
            <figcaption class="quote-segment__citation">
                <cite>{{ segmentData.name || "Name" }}{{ segmentData.date ? `, ${segmentData.date}` : "" }}</cite>
            </figcaption>
        </figure>
    </div>
</template>

<script>
export default {
    props: {
        id: String,
        segmentData: Object,
    },
};
</script>

<style lang="scss"></style>
